// add includes prototype for IE
if (!String.prototype.includes) {
	String.prototype.includes = function(search, start) {
		if (typeof start !== 'number') {
			start = 0;
		}
		if (start + search.length > this.length) {
			return false;
		} else {
			return this.indexOf(search, start) !== -1;
		}
	};
}

(function($) {

var mobile = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
	mobile = true;
	$('body').addClass('hv-mobile');
}

var animElems, translateElems;
var windowWidth = document.body.clientWidth;

$(document).ready(function(){
	animElems = $('.hv-slider, .hv-hero, .hv-banner, .hv-block__lead, .hv-block__main, .hv-line, .hv-carousel, .hv-card, .search-item__main, .villa__banner');
	translateElems = $('.hv-block__main__text');
	$(window).scroll();
});

$(window).load(function(){	
	$(window).scroll();
});

$(window).resize(function(){
	if (!mobile && $('body').prop('clientWidth')>=1024) {
		translateFxn();
		$(window).scroll();
	}
})

$(window).scroll(function(){
	if (!mobile && $('body').prop('clientWidth')>=1024) {
		if (animElems) {
			animElems.each(function(){
				var classList = $(this).attr('class');
				if (isPast($(this)) && !classList.includes('animating')) {			
					$(this).addClass('animating');
					// animate rotating banner
					if (classList.includes('hv-slider')) {
						var slides 	= $(this).find('.hv-slider__slides');
						var overlay = $(this).find('.hv-slider__overlay');
						var scroll 	= $('.hv-scroll');
						// animate slider slides area
						slides.animate({
							opacity:1
						},800);
						// animate slider overlay
						overlay.delay(800).animate({opacity:1,left:0,},800);
						// animate scroller
						scroll.delay(1600).animate({opacity:1},800);
					}
					// animate static banner
					if (classList.includes('hv-hero')) {
						var img 	= $(this).find('.hv-hero__heightWrap');
						var overlay = $(this).find('.hv-hero__overlay');
						var scroll 	= $('.hv-scroll');
						// animate hero img area
						img.animate({
							opacity:1,
							'border-bottom-width':'50px',
							'border-right-width':'86px',
							'border-left-width':'86px'
						},1000);
						// animate slider overlay
						overlay.delay(800).animate({opacity:1,left:0,},800);
						// animate scroller
						scroll.delay(1600).animate({opacity:1,top:'395px'},800);
					}
					// animate cta banner
					if (classList.includes('hv-banner')) {
						var scroll 	= $('.hv-scroll--banner');
						// animate scroller
						scroll.delay(200).animate({opacity:1},800);
					}
					// animate content block leads
					if (classList.includes('hv-block__lead')) {
						$(this).animate({opacity:1},400);
					}
					// animate content block main areas
					if (classList.includes('hv-block__main')) {
						var images	= $(this).find('.hv-block__main__images');
						var text	= $(this).find('.hv-block__main__text');
						// animate images
						images.delay(400).animate({opacity:1},400,function(){
							$(window).trigger('blockHeight');
						});
						// animate text
						text.delay(600).animate({opacity:1},400);
					}
					// animate search text areas
					if (classList.includes('search-item__main')) {
						$(this).delay(200).animate({opacity:1},400);
					}
					// animate content line
					if (classList.includes('hv-line')) {					
						
					}
					// animate carousel
					if (classList.includes('hv-carousel')) {
						var lead 	= $(this).find('.hv-carousel__lead');
						var images	= $(this).find('.hv-carousel__slides');
						var text 	= $(this).find('.hv-carousel__main');
						// animate lead
						lead.animate({opacity:1},400);
						// animate images
						images.delay(300).animate({opacity:1},500);
						// animate text
						text.delay(700).animate({opacity:1},500);
					}
					// animate cards
					if (classList.includes('hv-card')) {
						var text = $(this).find('.hv-card__main__text');
						text.delay(200).animate({opacity:1},600);
					}
				}
			});	
		}
		translateFxn();
	}
});

function translateFxn() {
	if (translateElems) {
		translateElems.each(function(){
			var classList 	= $(this).attr('class');		
			if (classList.includes('hv-block__main__text')) {
				var winTop 		= $(window).scrollTop();				
				var offset 		= $(window).outerHeight()/4;					
				var winQuart	= winTop + offset;
				var winHalf		= winTop + (offset*2);
				var win3Quart	= winTop + (offset*3);	
				var winBottom 	= winTop + (offset*4);
				var parentTop 	= $(this).parent().offset().top;

				var translate	= 300-(Math.max(0,winHalf - parentTop));
				if (translate < 0) { translate = 0; }			
				$(this).css('top',translate+'px');
				// $(this).animate({top:translate+'px'},10);
			}
		});
	}
}

function inView(elem)
{
	// find top 25%, bottom 25% of screen
    var winTop	 		= $(window).scrollTop();
    var winHeight	 	= $(window).height();
    var topQuart 		= winTop + (winHeight/4);
    var botQuart 		= winTop + (winHeight/4)*3;

    var elemTop 		= $(elem).offset().top;
    var elemHeight 		= $(elem).outerHeight();
    var elemMiddle		= elemTop + (elemHeight/2);

    return ((elemMiddle > topQuart) && (elemMiddle < botQuart));
}

function isPast(elem) {
	// returns true if the bottom of the window is past the top of the element
	var winBottom 	= $(window).scrollTop() + $(window).outerHeight();
	var elemTop 	= $(elem).offset().top;
	var offset 		= $(window).outerHeight()/5; // make it so it's not the exact bottom of the window
	return winBottom-offset > elemTop;
}

})( jQuery );  